















import Vue, { PropType } from 'vue';
import SectionForm, {
  FormDataInterface,
} from '@/containers/cv-section-text/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionTextStoreEdit from '@/store/modules/cvSectionTextEdit';
import { CvSectionText } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionForm,
  },
  props: {
    section: {
      type: Object as PropType<CvSectionText>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, content }: FormDataInterface) {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionTextStoreEdit.UpdateCvSectionText.namespaced({
          params: {
            cv_id,
            id,
          },
          body: {
            title,
            content,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionTextStoreEdit.DeleteCvSectionText.namespaced({
          params: {
            cv_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
